var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChange24 = function SvgChange24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 1.8A1 1 0 0 0 4.4.2l-4 3a1 1 0 0 0 0 1.6l4 3a1 1 0 1 0 1.2-1.6L4 5h10a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V8a5 5 0 0 0-5-5H4l1.6-1.2ZM14.4 18.2a1 1 0 0 0 1.2 1.6l4-3a1 1 0 0 0 0-1.6l-4-3a1 1 0 0 0-1.2 1.6L16 15H6a3 3 0 0 1-3-3v-1a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h10l-1.6 1.2Z",
    fill: "#242424"
  })));
};
export default SvgChange24;